import { render, staticRenderFns } from "./EventsProducts.vue?vue&type=template&id=3db0d560&"
import script from "./EventsProducts.vue?vue&type=script&lang=js&"
export * from "./EventsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventsProducts.vue"
export default component.exports